(function () {'use strict';}());

angular.module('app').filter('conditionalquestions', function() {
    return function(questions) {
    	if(!questions) return questions;
        var trace = angular.trace;
    	var results = [];
        var triggers = questions.filter(filterQuestions,{ids: [2,4,5], threshold: 1}).concat(questions.filter(filterQuestions,{ids: [3], threshold: 3}));
        var standard = questions.filter(function(q){return q.conditional === false; });
        if(!triggers.length) return standard;
        return questions;
    };


    function filterQuestions(question){
        if(this.ids.indexOf(question.id) === -1 || !question.userResponse || !question.userResponse.value) return false;
        if(question.userResponse.value >= this.threshold) return true;
        return false;
    }
});